import React, { JSX } from "react";

export const Heading: React.FC<{ text: string; rightItem?: JSX.Element }> = (
    props
) => {
    const { text, rightItem } = props;

    return (
        <div
            style={{
                paddingTop: 32,
                fontSize: "115%",
                fontWeight: "bold",
                letterSpacing: 0.15,
                display: "flex",
                alignItems: "center",
            }}
        >
            <div style={{ flexGrow: 1 }}>{text}</div>
            {rightItem}
        </div>
    );
};
